<!-- This is a Vue duplicate of:
    dt-membership-unredeemable-info.html
    membershipUnredeemableInfoDirective.js
-->
<template>
    <div class="membership-unredeemable-info"
         data-component="MembershipUnredeemableInfo">
        <div v-if="!membership.currentPlan.membershipsCanBeRedeemedToday"
             class="alert alert--small alert-warning mb-05"
             :class="alertClasses">
            {{
                l('MEMBERSHIPS.ONLY_REDEEMABLE_BETWEEN', {
                    fromDate: membership.currentPlan.allowedUsageFromDate,
                    toDate: membership.currentPlan.allowedUsageToDate
                })
            }}
        </div>

        <div v-if="subscription.isAtMaximumVisits()"
             class="alert alert--small alert-warning mb-05"
             :class="alertClasses">
            {{ l('MEMBERSHIPS.MAX_REDEMPTIONS_REACHED') }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        /**
         * @type {Membership}
         */
        membership: {
            type: Object,
            required: true,
        },

        /**
         * @type {MembershipSubscription}
         */
        subscription: {
            type: Object,
            required: true,
        },

        /**
         * Additional CSS classes for the alert
         */
        alertClasses: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="less">
.membership-unredeemable-info {
    &:empty {
        display: none;
    }
}
</style>
